// external
import * as React from 'react';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export type CircularProgressWithLabelProps = CircularProgressProps & {
  value: number;
  color?: string;
};

export default function CircularProgressWithLabel(props: CircularProgressWithLabelProps) {
  const { color, ...circularProps } = props;
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        {...circularProps}
        sx={{
          ...circularProps.sx,
          color:
            color === 'success'
              ? 'success.main'
              : color === 'warning'
              ? 'warning.main'
              : color === 'primary'
              ? 'primary.main'
              : 'primary.main',
        }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" color={'black'}>
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
